/**
 * Voluum tracking token placeholders (lander / click URLs).
 * Source: https://doc.voluum.com/article/voluum-tracking-tokens
 * Plus common lander-URL tokens from the Voluum panel (offer/lander/flow, cachebuster).
 * For Media Devoted | Created By Ciro Autiero
 */

const VOLUUM_DOC_TOKENS: readonly string[] = [
  '{clickid}',
  '{externalid}',
  '{externalidparameter}',
  '{click.id}',
  '{payout}',
  '{cost}',
  '{campaign.id}',
  '{campaign.name}',
  '{trafficsource.id}',
  '{trafficsource.name}',
  '{device}',
  '{brand}',
  '{model}',
  '{browser}',
  '{browserversion}',
  '{os}',
  '{osversion}',
  '{country}',
  '{countryname}',
  '{region}',
  '{city}',
  '{isp}',
  '{connection.type}',
  '{carrier}',
  '{ip}',
  '{referrerdomain}',
  '{language}',
  '{transaction.id}',
  '{eventType}',
  '{conversion.cost}',
  '{workspace.id}',
  '{workspace.name}',
  '{path.id}',
  '{path.name}',
  '{flow.id}',
  '{useragent}',
  '{trackingdomain}',
  '{postbacktime}',
  '{payout.currency}',
  '{offer.id}',
  '{offer.name}',
  '{lander.id}',
  '{lander.name}',
  '{cachebuster}',
];

const VAR_TOKENS = Array.from({ length: 10 }, (_, i) => `{var${i + 1}}`);

const PARAM_TOKENS = [1, 2, 3, 4, 5].map((n) => `{param${n}}`);

/** Ordered list for the token picker (no duplicates). */
export const VOLUUM_LANDER_URL_TOKEN_LIST: string[] = [
  ...VOLUUM_DOC_TOKENS,
  ...VAR_TOKENS,
  '{var:variable name}',
  ...PARAM_TOKENS,
];

export const VOLUUM_TRACKING_TOKENS_DOC_URL =
  'https://doc.voluum.com/article/voluum-tracking-tokens';

export function appendVoluumTokenToUrl(url: string, token: string): string {
  const u = url.trimEnd();
  const t = token.trim();
  if (!t) return url;
  if (!u) return t;
  return u + t;
}
